import { useCallback } from 'react';
import { mergePriceRefreshOptions } from '../dashboardUtils';

export default function useQueuedPriceRefresh({
    priceRefreshQueuedRef,
    queuedPriceRefreshOptionsRef,
}) {
    const queuePriceRefresh = useCallback((options = {}) => {
        priceRefreshQueuedRef.current = true;
        queuedPriceRefreshOptionsRef.current = mergePriceRefreshOptions(
            queuedPriceRefreshOptionsRef.current,
            options,
        );
    }, [priceRefreshQueuedRef, queuedPriceRefreshOptionsRef]);

    const consumeQueuedPriceRefresh = useCallback(() => {
        if (!priceRefreshQueuedRef.current) {
            return null;
        }

        const queuedOptions = queuedPriceRefreshOptionsRef.current || {
            syncPosSizingDraft: false,
            reason: 'price_refresh',
        };

        priceRefreshQueuedRef.current = false;
        queuedPriceRefreshOptionsRef.current = null;
        return queuedOptions;
    }, [priceRefreshQueuedRef, queuedPriceRefreshOptionsRef]);

    return {
        queuePriceRefresh,
        consumeQueuedPriceRefresh,
    };
}
